(() => {
  const nav = document.querySelector('.pgj-mobile-bottom-nav');
  const mobileQuery = window.matchMedia('(max-width: 760px)');

  if (!nav || !mobileQuery.matches) return;

  let lastScrollY = window.scrollY;
  let ticking = false;

  const updateNav = () => {
    const currentScrollY = window.scrollY;
    const scrollDelta = currentScrollY - lastScrollY;

    if (currentScrollY <= 80 || scrollDelta < -4) {
      nav.classList.remove('is-hidden');
    } else if (scrollDelta > 4) {
      nav.classList.add('is-hidden');
    }

    lastScrollY = currentScrollY;
    ticking = false;
  };

  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(updateNav);
      ticking = true;
    }
  }, { passive: true });
})();
